class CyclingBanner {
  constructor(element) {
    this.container = element;
    this.items = Array.from(this.container.querySelectorAll('.banner__media--cycling'));

    this.currentIndex = 0;
    this.totalItems = this.items.length;
    this.isAnimating = false;
    this.autoPlay = this.container.dataset.autoCycle === 'true';
    this.interval = parseInt(this.container.dataset.cycleSpeed) || 5000;
    this.autoPlayTimer = null;

    // Debug: Log the settings being used
    console.log(`Banner initialized with:`, {
      autoCycle: this.autoPlay,
      cycleSpeed: this.container.dataset.cycleSpeed,
      interval: this.interval,
      totalItems: this.totalItems
    });

    if (this.totalItems > 1) {
      this.init();
    }
  }

  init() {
    this.showCurrentItem();

    if (this.autoPlay && this.totalItems > 1) {
      this.startAutoPlay();
    }
  }

  showCurrentItem() {
    if (this.isAnimating) return;

    this.isAnimating = true;

    // Hide all items
    this.items.forEach((item) => {
      item.classList.remove('active');
    });

    // Show current item
    if (this.items[this.currentIndex]) {
      this.items[this.currentIndex].classList.add('active');
    }

    // Reset animation flag - reduced timeout for faster cycling
    setTimeout(() => {
      this.isAnimating = false;
    }, 100);
  }

  nextItem() {
    if (this.totalItems <= 1) return;

    this.currentIndex = (this.currentIndex + 1) % this.totalItems;
    this.showCurrentItem();
  }

  startAutoPlay() {
    if (!this.autoPlay || this.totalItems <= 1) return;

    // Clear any existing timer first
    this.pauseAutoPlay();

    // Debug: Log the interval being used
    console.log(`Starting autoplay with interval: ${this.interval}ms`);

    // Start cycling immediately at constant rate
    this.autoPlayTimer = setInterval(() => {
      this.nextItem();
    }, this.interval);
  }

  pauseAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }

  destroy() {
    this.pauseAutoPlay();
  }
}

// Initialize cycling banners when DOM is loaded
function initCyclingBanners() {
  const cyclingBanners = document.querySelectorAll('.banner--cycling');
  cyclingBanners.forEach(banner => {
    new CyclingBanner(banner);
  });
}

// Initialize on DOM content loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCyclingBanners);
} else {
  initCyclingBanners();
}

// Re-initialize if content is dynamically loaded
document.addEventListener('shopify:section:load', initCyclingBanners);